module.exports = __webpack_public_path__ + "static/media/logo.818055c9.svg";